import { useEffect, useState } from "react";
import * as echarts from "echarts";
import ReactECharts from "echarts-for-react";

function GeoRender({
  geoData,
  geoFileUrl,
  title = "Map Chart",
  regionNameKey = "name",
  mapName = "custom-map",
  colorRange = ["#e0f3f8", "#2166ac"],
}) {
  const [mapLoaded, setMapLoaded] = useState(false);

  const dataMapped = Object.entries(geoData).map(([key, value]) => ({
    name: key,
    value,
  }));

  useEffect(() => {
    fetch(geoFileUrl)
      .then((res) => res.json())
      .then((geoJson) => {
        geoJson.features.forEach((feature) => {
          feature.properties.name = feature.properties[regionNameKey];
        });

        echarts.registerMap(mapName, geoJson);
        setMapLoaded(true);
      })
      .catch((err) => {
        console.error("Failed to load GeoJSON:", err);
      });
  }, [geoFileUrl, regionNameKey, mapName]);

  const mapOption = {
    title: {
      text: title,
      left: "center",
      textStyle: {
        fontSize: 16,
      },
    },
    tooltip: {
      trigger: "item",
      formatter: ({ name, value }) =>
        `${name}: ${value ? value.toLocaleString() : 0}`,
    },
    visualMap: {
      min: 0,
      max: Math.max(...Object.values(geoData)),
      left: "left",
      top: "bottom",
      text: ["High", "Low"],
      inRange: {
        color: colorRange,
      },
      calculable: true,
    },
    series: [
      {
        name: title,
        type: "map",
        map: mapName,
        roam: true,
        emphasis: {
          label: {
            show: true,
          },
        },
        data: dataMapped,
      },
    ],
  };

  const onEvents = {
    click: (params) => {
      console.log("Clicked region info:", params);
    },
  };

  return (
    <div style={{ height: "500px", width: "100%" }}>
      {mapLoaded ? (
        <ReactECharts
          option={mapOption}
          style={{ height: "100%", width: "100%" }}
          onEvents={onEvents} 
        />
      ) : (
        <p>Loading map...</p>
      )}
    </div>
  );
}

export default GeoRender;
